export default __webpack_public_path__ + "static/drive-you-crazy-dcb2cbc9b4cb417ed3fcb6e27144c501.jpg";